export default __webpack_public_path__ + "static/media/map.737d1d50.svg";